import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import AdminGate from "@/components/AdminGate";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AnnouncementBar from "@/components/AnnouncementBar";
import EmailPopup from "@/components/EmailPopup";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CustomOrderPage from "@/pages/CustomOrderPage";
import CartPage from "@/pages/CartPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import BlogAdminPage from "@/pages/BlogAdminPage";
import ProductAdminPage from "@/pages/ProductAdminPage";
import ReturnsPage from "@/pages/ReturnsPage";
import ContactPage from "@/pages/ContactPage";
import BusinessCardPage from "@/pages/BusinessCardPage";
import GiftVoucherPage from "@/pages/GiftVoucherPage";
import CollectionPage from "@/pages/CollectionPage";
import BraceletBuilderPage from "@/pages/BraceletBuilderPage";
import ShippingPage from "@/pages/ShippingPage";
import WishlistPage from "@/pages/WishlistPage";
import AboutPage from "@/pages/AboutPage";
import MarketsAdminPage from "@/pages/MarketsAdminPage";
import DiscountsAdminPage from "@/pages/DiscountsAdminPage";
import KeepsakeCardPage from "@/pages/KeepsakeCardPage";
import EmailsAdminPage from "@/pages/EmailsAdminPage";
import AdminHomePage from "@/pages/AdminHomePage";
import AdminSocialPage from "@/pages/AdminSocialPage";
import OrdersAdminPage from "@/pages/OrdersAdminPage";
import ProductBulkImportPage from "@/pages/ProductBulkImportPage";
import SizingGuidePage from "@/pages/SizingGuidePage";
import KeepsakeCardsPrintPage from "@/pages/KeepsakeCardsPrintPage";
import GalleryPage from "@/pages/GalleryPage";
import GalleryAlbumPage from "@/pages/GalleryAlbumPage";
import GallerySubmitPage from "@/pages/GallerySubmitPage";
import GalleryAdminPage from "@/pages/GalleryAdminPage";
import AdminAccountPage from "@/pages/AdminAccountPage";

function App() {
  return (
    <AdminAuthProvider>
    <CartProvider>
      <div className="App min-h-screen flex flex-col" style={{ backgroundColor: '#FAF9F6' }}>
        <BrowserRouter>
          <AnnouncementBar />
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:productId" element={<ProductDetailPage />} />
              <Route path="/custom" element={<CustomOrderPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/admin/blog" element={<AdminGate><BlogAdminPage /></AdminGate>} />
              <Route path="/admin/products" element={<AdminGate><ProductAdminPage /></AdminGate>} />
              <Route path="/returns" element={<ReturnsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/business-card" element={<BusinessCardPage />} />
              <Route path="/gift-voucher" element={<GiftVoucherPage />} />
              <Route path="/collections/:occasion" element={<CollectionPage />} />
              <Route path="/builder" element={<BraceletBuilderPage />} />
              <Route path="/shipping" element={<ShippingPage />} />
              <Route path="/sizing-guide" element={<SizingGuidePage />} />
              <Route
                path="/admin/products/:productId/print-keepsake-cards"
                element={<AdminGate><KeepsakeCardsPrintPage /></AdminGate>}
              />
              <Route path="/wishlist" element={<WishlistPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/admin/markets" element={<AdminGate><MarketsAdminPage /></AdminGate>} />
              <Route path="/admin/discounts" element={<AdminGate><DiscountsAdminPage /></AdminGate>} />
              <Route path="/keepsake-card" element={<KeepsakeCardPage />} />
              <Route path="/admin/emails" element={<AdminGate><EmailsAdminPage /></AdminGate>} />
              <Route path="/admin" element={<AdminGate><AdminHomePage /></AdminGate>} />
              <Route path="/admin/orders" element={<AdminGate><OrdersAdminPage /></AdminGate>} />
              <Route path="/admin/social" element={<AdminGate><AdminSocialPage /></AdminGate>} />
              <Route path="/admin/products/bulk-import" element={<AdminGate><ProductBulkImportPage /></AdminGate>} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/gallery/submit" element={<GallerySubmitPage />} />
              <Route path="/gallery/:slug" element={<GalleryAlbumPage />} />
              <Route path="/admin/gallery" element={<AdminGate><GalleryAdminPage /></AdminGate>} />
              <Route path="/admin/gallery/:albumId" element={<AdminGate><GalleryAdminPage /></AdminGate>} />
              <Route path="/admin/account" element={<AdminGate><AdminAccountPage /></AdminGate>} />
            </Routes>
          </main>
          <Footer />
          <EmailPopup />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </CartProvider>
    </AdminAuthProvider>
  );
}

export default App;

